import { useEffect } from 'react';

const upsert = (selector, create) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = create();
    document.head.appendChild(element);
  }
  return element;
};

/**
 * Sets the document title, description and canonical URL for a route.
 *
 * NOTE: this runs in the browser, so search engines that execute JavaScript
 * pick it up but social-media crawlers generally do not. The Open Graph tags
 * in public/index.html therefore stay describing the landing page. Giving the
 * legal routes their own share previews needs prerendering, which this CRA
 * setup does not do.
 */
export default function useDocumentMeta({ title, description, canonicalPath }) {
  useEffect(() => {
    const previousTitle = document.title;
    if (title) document.title = title;

    if (description) {
      const tag = upsert('meta[name="description"]', () => {
        const meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        return meta;
      });
      tag.setAttribute('content', description);
    }

    if (canonicalPath) {
      const link = upsert('link[rel="canonical"]', () => {
        const element = document.createElement('link');
        element.setAttribute('rel', 'canonical');
        return element;
      });
      link.setAttribute('href', new URL(canonicalPath, window.location.origin).href);
    }

    return () => {
      document.title = previousTitle;
    };
  }, [title, description, canonicalPath]);
}
